const recuperarSenhaNovaSenhaInitalValues = (guid) => ({
    Guid: guid,
    Senha: '',
    ConfirmarSenha: '',
});
export default recuperarSenhaNovaSenhaInitalValues;
